import { Box, Card, CardProps, Skeleton, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { forwardRef } from "react"

type DirectorySkeletonVariant = "vertical" | "horizontal"

interface IDirectorySkeletonCardProps extends Omit<CardProps, "variant"> {
  variant?: DirectorySkeletonVariant
}

export const DirectorySkeletonCard = forwardRef<
  HTMLDivElement,
  IDirectorySkeletonCardProps
>(({ variant = "horizontal", sx = {}, ...props }, ref) => {
  const theme = useTheme()
  const componentStyleKey =
    variant === "horizontal"
      ? "DirectorySkeletonCard"
      : "VerticalDirectorySkeletonCard"

  const { styleOverrides = {} } = theme.components?.[componentStyleKey] || {}
  const {
    root,
    avatar,
    cardContent,
    primaryText,
    divider,
    secondaryText,
    logo,
  } = styleOverrides

  return (
    <Card sx={deepmerge(root, sx)} ref={ref} {...props}>
      <Skeleton sx={logo} variant="rounded" />
      <Skeleton
        className="DirectorySkeletonCard-avatar"
        sx={avatar}
        variant="rectangular"
      />
      <Box sx={cardContent}>
        <Skeleton sx={primaryText} variant="text" width="80%" />
        <Skeleton sx={divider} variant="rectangular" />
        <Skeleton sx={secondaryText} variant="text" width="60%" />
      </Box>
    </Card>
  )
})
